export const selectUserInfo = state => state.info.currentUserInfo;
export const selectUserInfoById = state => state.info.userInfoById;
export const selectAllPatients = state => state.info.allPatients;
export const selectAllDoctors = state => state.info.allDoctors;
export const selectInstitution = state => state.info.allInstitution;
